module.exports = __webpack_public_path__ + "static/media/52732928_2452985544776622_7889796184779259904_o.13656278.jpg";